import React from 'react';

import { CatchInfoCard } from '../../../../../../Cards/CatchInfoCard/CatchInfoCard';
import { CTAButton } from '../../../../../../Clickables/Buttons/CTAButton/CTAButton';
import { Text } from '../../../../../../Text/Text';

import { catchesInfoCardsData } from './catchesInfoCardsData';

interface BasicCatchInfoCardsProps {
  showCTAButton: boolean;
}

export const BasicCatchInfoCards = ({ showCTAButton }: BasicCatchInfoCardsProps) => {
  const ctaButtonContent = 'Unlock catch conditions';
  const weatherDataComment = 'Weather data for some catches may vary.';

  return (
    <>
      <div className="mb-4 grid grid-cols-1 grid-rows-1">
        <div className="col-start-1 row-start-1 grid grid-cols-3 gap-2">
          {catchesInfoCardsData.map(({ id, bottomText, iconComponent }) => (
            <CatchInfoCard key={id} bottomText={bottomText} iconComponent={iconComponent} />
          ))}
        </div>
        {showCTAButton && (
          <div className="col-start-1 row-start-1 flex items-center justify-center">
            <CTAButton type="pro" source="catch-viewer-conditions" variant="buttonPro">
              {ctaButtonContent}
            </CTAButton>
          </div>
        )}
      </div>
      <Text className="text-abyss" variant="xs">
        {weatherDataComment}
      </Text>
    </>
  );
};
